import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '@/state/contexts';
import { useLogoutMutation } from '@/state/slices/auth';
import { performClientLogout } from '@/state/utils/authSession';

export function useLogout() {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [logoutFn] = useLogoutMutation();

  const logout = useCallback(() => {
    performClientLogout(logoutFn, setUser);
    navigate('/login');
  }, [logoutFn, setUser, navigate]);

  return logout;
}
